import { render, staticRenderFns } from "./marketplaces.vue?vue&type=template&id=0efde965"
import script from "./marketplaces.vue?vue&type=script&lang=js"
export * from "./marketplaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports